import {SecurityScan} from './security-scan';

export class SecurityScanMapper {

  public static map(data: any): SecurityScan {
    const securityScan: SecurityScan = new SecurityScan();

    securityScan.id = data.id;

    return securityScan;
  }

}
